export const CHART_HISTORY = [
  { label: 'Past 12 Months', value: 13 },
  { label: 'Past 18 Months', value: 19 },
  { label: 'Past 24 Months', value: 25 },
  { label: 'All Time', value: 0 },
]
